define(['jquery'], function($){
//    (function( $ ){

        var __pluginDefaults = {
            enable : 'numeric'
        };

        $.fn.disableChars = function(options) {
            var opts = $.extend(true, {}, { _pluginVars: {}}, __pluginDefaults, options);
            $.fn.disableChars.init(this, opts);
        };

        $.fn.disableChars.init = function(objs, o) {
            var	privateOptions = $.extend(true, {}, o);
            if (o.enable == 'numeric') {
                objs.keypress(function(e) {
                    var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
                    if (!(
                        key == 46 ||         				//	.
                        key == 44 ||         				//	,
                            key == 48 ||         				//	0
                            key == 49 ||         				//	1
                            key == 50 ||         				//	2
                            key == 51 ||         				//	3
                            key == 52 ||         				//	4
                            key == 53 ||         				//	5
                            key == 54 ||         				//	6
                            key == 55 ||         				//	7
                            key == 56 ||         				//	8
                            key == 57 ||         				//	9
                            key == 8 ||          				//	backspace
                            key == 9 ||          				//	tab
                            key == 13 ||         				//	enter
                            key == 35 ||         				//	end
                            key == 36 ||         				//	home
                            key == 37 ||         				//	left
                            key == 39 ||         				//	right
                            key == 46 ||         				//	del
                            (e.ctrlKey && key == 97) ||         //	ctrl + a
                            (e.ctrlKey && key == 99) ||         //	ctrl + c
                            (e.ctrlKey && key == 118) ||           //	ctrl + v
                            (e.ctrlKey && key == 120)           //	ctrl + x
                        )) {
                        e.preventDefault();

                    } else if (
                        e.shiftKey && e.charCode == 35 ||	//  hash
                            e.shiftKey && e.charCode == 36 ||   // dolar
                            e.shiftKey && e.keyCode == 35 ||	//  hash
                            e.shiftKey && e.keyCode == 36 ||   // dolar
                            e.shiftKey && key == 37 ||          // czech percent
                            //e.keyCode == 39 ||          // czech percent
                            e.charCode == 39                    // single quotes
                        ) {
                        e.preventDefault();

                    } else if ( key == 13 ) {
                      console.log('enter');
                      e.preventDefault();
                      $(this).trigger('blur');
                    } else {
                      //e.preventDefault();
                    }
                });
                objs.bind('paste', function(e) {
                    e.preventDefault();
                });
            }
        }
    });



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.disableChars.js